import { ProductVersion, Program, ProgramV2, RelatedProgram, RelatedSeries, Series } from 'frontend/types';
import { capitalize } from 'frontend/utils/helpers';
import AnchorTag from './AnchorTag/AnchorTag';
import styles from './ProductRelations.module.css';

// TODO: rewrite this to be more readable
// eslint-disable-next-line react/display-name
const insertWord = (word: string) => (previous, current, index: number) => index === 0 ? [current] : [previous, word, <span key={index} className={styles.marginRight} />, current];
const onlyOtherVersionIsOriginal = (otherVersion: ProductVersion[]) => otherVersion.every(version => version.version === 'ORIGINAL');
const onlyOtherVariantIsOriginal = (otherVariants: {
  label: string;
}[]) => otherVariants.every(variant => variant.label === 'original');
const getAnchorTagIfAvailable = (versions: ProductVersion[], variants: (RelatedSeries | RelatedProgram)[], versionName: string, displayText: string) => {
  const currentVersion = versions.find(version => version.version === versionName);
  const currentVariant = variants.find(variant => variant.label == versionName);
  const link = currentVersion ? currentVersion.link : currentVariant?.link;
  return link ? <AnchorTag link={link} versionName={versionName} text={capitalize(displayText)} key={versionName} data-sentry-element="AnchorTag" data-sentry-component="getAnchorTagIfAvailable" data-sentry-source-file="ProductRelations.tsx" /> : null;
};
const getOtherVersionsAndVariants = (currentProduct: Program | Series | ProgramV2, leadingText = 'Finns även', isSeriesPage: boolean) => {
  const allVersions = isSeriesPage && 'series' in currentProduct && currentProduct.series ? currentProduct.series?.allVersions : currentProduct.allVersions;
  const currentVersion = isSeriesPage && 'series' in currentProduct ? currentProduct.series?.version : currentProduct.version;
  const otherVersions = allVersions.filter(version => version.version !== currentVersion) || [];
  const allVariants: (RelatedSeries | RelatedProgram)[] = isSeriesPage && 'series' in currentProduct && currentProduct.series?.relations?.variants ? currentProduct.series.relations?.variants : currentProduct.relations?.variants || [];
  if (otherVersions.length === 0 && allVariants.length === 0) return null;
  if (onlyOtherVersionIsOriginal(otherVersions) && onlyOtherVariantIsOriginal(allVariants) && otherVersions.length === 1) {
    return <>
        {`${leadingText} `}
        {getAnchorTagIfAvailable(otherVersions, allVariants, 'ORIGINAL', 'utan tolkning')}
      </>;
  }
  const audioDescriptionElement = getAnchorTagIfAvailable(otherVersions, allVariants, 'AUDIO_DESCRIPTION', 'syntolkat');
  const signLanguageElement = getAnchorTagIfAvailable(otherVersions, allVariants, 'SIGN_LANGUAGE', 'teckenspråkstolkat');
  const versionArray = [audioDescriptionElement, signLanguageElement].filter(Boolean);
  const originalWithoutInterpretationElement = getAnchorTagIfAvailable(otherVersions, allVariants, 'ORIGINAL', 'utan tolkning');
  const noOriginalInTheVariants = !allVariants.map(variant => variant.label).includes('original');
  if (originalWithoutInterpretationElement && noOriginalInTheVariants) {
    versionArray.push(originalWithoutInterpretationElement);
  }
  const variantArray = allVariants.map(variant => getAnchorTagIfAvailable(otherVersions, allVariants, variant.label, variant.label)).filter(Boolean);
  const allVersionsAndVariants = [...versionArray, ...variantArray];
  return <>
      {`${leadingText} som `}
      <span key={'key'} className={styles.marginRight} />
      {allVersionsAndVariants.reduce(insertWord(' · '), [])}
    </>;
};
interface Props {
  currentProduct: Program | Series | ProgramV2;
  leadingText?: string;
  dataTrk: 'series_banner' | 'program_description';
  isSeriesPage: boolean;
}
const ProductRelations = ({
  currentProduct,
  leadingText,
  dataTrk,
  isSeriesPage
}: Props) => {
  return <p data-testid="versions" data-trk-related-link-block={dataTrk} className={styles.versions} data-sentry-component="ProductRelations" data-sentry-source-file="ProductRelations.tsx">
      {getOtherVersionsAndVariants(currentProduct, leadingText, isSeriesPage)}
    </p>;
};
export default ProductRelations;